import CONFIG from '../../config'
import { /* IAuthRegister, */ IAuthLogin, IAuthForgotPassword, AuthRoles, IAuthUserCurrent } from '../models'
import api from './data.services'
import { storage } from './'

const registerSrv = 'patients'
const loginSrv = 'auth/login'
const logoutSrv = 'auth/logout'
const loginAdminSrv = 'auth/login/administrators'
const forgotPasswordSrv = 'auth/recover/passwords'
const userCurrentSrv = 'currentUser'
const userTokenSrv = 'auth/token'

const register = async (patientData: FormData) => {
  try {
    const resp: any = await api.post(registerSrv, patientData)

    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data && resp.data.patient ? resp.data.patient : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error) {
    return {
      status: 'Error',
      error
    }
  }
}

const login = async (loginData: IAuthLogin, role: AuthRoles = '') => {
  try {
    const resp: any = await api.post((role === CONFIG.AUTH.ROLES.ADMIN ? loginAdminSrv : loginSrv), loginData)

    if(resp) {
      const { data } = resp

      if(data && data.token) {
        return {
          status: 'Ok',
          data
        }
      }
    }

    return {
      status: 'Error',
      error: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      error
    }
  }
}

const forgetPassword = async (fpData: IAuthForgotPassword) => {
  try {
    const resp: any = await api.post(forgotPasswordSrv, fpData)

    if(resp) {
      const { data } = resp

      if(data && data.patient && data.patient.document_number) {
        return {
          status: 'Ok',
          data
        }
      }
    }

    return {
      status: 'Error',
      error: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      error
    }
  }
}

const isLoggedIn = (role: AuthRoles = '') => {
  const currentUser: any = storage.get(userCurrentSrv)

  if(role === CONFIG.AUTH.ROLES.ADMIN) {
    return (currentUser && currentUser.token && currentUser.info && (currentUser.info.rol === CONFIG.AUTH.ROLES.ADMIN || currentUser.info.rol === CONFIG.AUTH.ROLES.SUPERADMIN) ? true : false)
  } else {
    return (currentUser && currentUser.token ? true : false)
  }
}

const isUserSessionExpired = () => {
  let userCurrent: any = getUserCurrentStorage()

  if(userCurrent && userCurrent.info) return userCurrent.info.sessionExpired
  return false
}

const setUserCurrentStorage = (data: IAuthUserCurrent) => {
  return storage.set(userCurrentSrv, data)
}

const setUserCurrentSessionExpired = (expireSw: boolean = false) => {
  let userCurrent: any = getUserCurrentStorage()

  if(userCurrent && userCurrent.info) {
    userCurrent.info.sessionExpired = expireSw
    setUserCurrentStorage(userCurrent)
  }
}

const setUserCurrentPageRole = (role: AuthRoles) => {
  let userCurrent: any = getUserCurrentStorage()

  if(userCurrent.info) userCurrent.info.pageRole = role
  setUserCurrentStorage(userCurrent)
}

const getUserCurrentStorage = () => {
  return storage.get(userCurrentSrv)
}

const getUserCurrentInfoStorage = () => {
  const user = getUserCurrentStorage()
  return (user ? user.info : null)
}

const isRoleByUserCurrent = (role: AuthRoles = 'SUPER_ADMIN_ROLE') => {
  const user = getUserCurrentStorage()
  const { info } = user
  return (info.rol === role)
}

const getUserCurrentTokenStorage = () => {
  const user = getUserCurrentStorage()
  return (user ? user.token : '')
}

const getUserCurrentPageRole = () => {
  let userCurrent: any = getUserCurrentStorage()

  if(userCurrent.info) return userCurrent.info.pageRole
  return ''
}

const getUserTokenById = async (userId: string) => {
  try {
    const resp: any = await api.get(`${userTokenSrv}/${userId}`, getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.token ? resp.data.token : '')
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener token!'
    }
  }
}

const logout = async (userId: string) => {
  const token = getToken();
  storage.remove(userCurrentSrv)
  try {
      if(Number(userId) > 0) {
        await api.get(`${logoutSrv}/${userId}`, token)
      }
  } catch (error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener token!'
    }
  }
}

const getToken = () => {
  return { 'x-token': getUserCurrentTokenStorage() }
}

export const authService = {
  register,
  login,
  forgetPassword,
  logout,
  isLoggedIn,
  isUserSessionExpired,
  isRoleByUserCurrent,
  setUserCurrentStorage,
  setUserCurrentSessionExpired,
  setUserCurrentPageRole,
  getUserCurrentStorage,
  getUserCurrentInfoStorage,
  getUserCurrentTokenStorage,
  getUserCurrentPageRole,
  getUserTokenById,
  getToken
}